module.exports = __webpack_public_path__ + "img/fb-icon.6aa5ae14.svg";